import type { FunctionComponent, HTMLProps } from 'react'
import React from 'react'

import classnames from 'classnames'

import { TypographyV2 } from '../Seatbelt2/Foundations/Typography'
import styles from './Tag.module.scss'

export const Tag: FunctionComponent<TagProps> = ({
  className,
  text,
  ...rest
}) => {
  if (!text) {
    return null
  }

  return (
    <TypographyV2
      className={classnames(className, styles.tag)}
      tag="span"
      textStyle="sb-text-interface-body-x-small-regular"
      {...rest}
    >
      {text}
    </TypographyV2>
  )
}

///////// IMPLEMENTATION /////////

export type TagProps = {
  /**
   * Optional CSS class name that can be added to the Tag component.
   */
  className?: string
  /**
   * Text displayed inside of the Tag component.
   */
  text: string
} & HTMLProps<HTMLSpanElement>
